import { useCallback, useEffect, useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import toast from 'react-hot-toast';
import { PlayerFraudIndicatorsPanel } from '@kioskgaming/ui';
import AppLayout from '../components/layout/AppLayout';
import {
  fetchAgentPlayerFraudIndicatorDetail,
  fetchAgentPlayerFraudIndicators,
  fetchAgentPlayerFraudWithdrawalAnalysis,
  fetchShops,
  resolveAgentPlayerFraudIndicator,
} from '../services/api';

export default function FraudIndicatorsPage() {
  const [shopOptions, setShopOptions] = useState<Array<{ id: string; name: string }>>([]);
  const onError = useCallback((msg: string) => toast.error(msg), []);
  const onSuccess = useCallback((msg: string) => toast.success(msg), []);

  useEffect(() => {
    fetchShops()
      .then((res) => {
        const shops = (res.data || []) as Array<{ id: string; name: string }>;
        setShopOptions(shops.map((s) => ({ id: s.id, name: s.name })));
      })
      .catch(() => setShopOptions([]));
  }, []);

  return (
    <AppLayout contentWidth="fluid">
      <div className="w-full max-w-none bg-slate-50/90 px-1 pb-8 sm:px-0">
        <header className="border-b border-slate-200/80 pb-4">
          <div className="flex items-center gap-2">
            <ShieldAlert className="h-5 w-5 text-orange-500" />
            <h1 className="text-lg font-semibold tracking-tight text-slate-900">Fraud indicators</h1>
          </div>
          <p className="mt-1 max-w-2xl text-sm text-slate-600">
            Player transaction fraud flags across Shops you manage.
          </p>
        </header>
        <div className="mt-4">
          <PlayerFraudIndicatorsPanel
            fetchList={fetchAgentPlayerFraudIndicators}
            fetchDetail={fetchAgentPlayerFraudIndicatorDetail}
            fetchWithdrawalAnalysis={fetchAgentPlayerFraudWithdrawalAnalysis}
            resolveIndicator={resolveAgentPlayerFraudIndicator}
            showShopFilter
            shopOptions={shopOptions}
            onError={onError}
            onSuccess={onSuccess}
          />
        </div>
      </div>
    </AppLayout>
  );
}
